import React, { useEffect } from "react";
import { Badge, Dropdown, Menu, Button } from "antd";
import { Link, useParams, useLocation } from "react-router-dom";

import { EllipsisOutlined } from "@ant-design/icons";
import { viewAmenitiesList } from "../../Redux/Actions/amenitiesResaleActions";
import { useDispatch, useSelector } from "react-redux";
import TableComponent from "../../Global Functions/tableComponents";
// import DeleteFunction from "../../Globala Functions/deleteFunction";
import { ToFirstCapital } from "../../Utils/helpers";

const ViewAmenities = () => {
  const { id } = useParams();
  const location = useLocation();

  const amenityName = location.state?.amenityName || "Loading";

  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  const dispatch = useDispatch();

  useEffect(() => {
    const amenityData = {
      page: 1,
      limit: 100,
      category_id: "",
      unit_id: "",
      amenity_id: id,
    };
    dispatch(viewAmenitiesList(amenityData));
  }, [dispatch, id]);

  const { amenitiesResale } = useSelector((state) => state.amenitiesResale);

  const columns = [
    {
      title: "Sr. No.",
      align: "center",
      key: "sr no.",
      render: (_, __, index) => index + 1,
    },
    {
      title: " Name",
      align: "center",
      dataIndex: "name",
      key: "name",
    },
    // {
    //   title: "Business Type",
    //   align: "center",
    //   dataIndex: "business_type",
    //   key: "business_type",
    //   render: (types) => (
    //     <span>
    //       {Array.isArray(types) ? types.map(t => ToFirstCapital(t)).join(", ") : "-"}
    //     </span>
    //   ),
    // },
    {
      title: "Business Type",
      dataIndex: "business_type",
      key: "business_type",
      align: "center",
      render: (business_type) => {
        if (!business_type || (Array.isArray(business_type) && business_type.length === 0)) {
          return "N/A";
        }
        const types = Array.isArray(business_type) ? business_type : [business_type];
        return (
          <div style={{ display: "flex", flexWrap: "wrap", gap: 4, justifyContent: "center" }}>
            {types.map((type) => (
              <span
                key={type}
                style={{
                  padding: "2px 10px",
                  borderRadius: 999,
                  fontSize: 12,
                  fontWeight: 500,
                  textTransform: "capitalize",
                  background:
                    type === "fresh" ? "#ecfdf5" :
                      type === "resale" ? "#eff6ff" :
                        type === "business" ? "#fefce8" :
                          type === "rental" ? "#fdf4ff" : "#f3f4f6",
                  color:
                    type === "fresh" ? "#059669" :
                      type === "resale" ? "#2563eb" :
                        type === "business" ? "#ca8a04" :
                          type === "rental" ? "#9333ea" : "#6b7280",
                  border: `1px solid ${type === "fresh" ? "#a7f3d0" :
                    type === "resale" ? "#bfdbfe" :
                      type === "business" ? "#fde68a" :
                        type === "rental" ? "#e9d5ff" : "#e5e7eb"
                    }`,
                }}
              >
                {type}
              </span>
            ))}
          </div>
        );
      },
    },
    {
      title: "Image",
      align: "center",
      dataIndex: "image",
      key: "image",
      render: (record) => <img style={{ width: "50px" }} src={record} alt="" />,
    },
    {
      title: "Status",
      align: "center",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            padding: "4px 8px",
            border: "1px solid #d9d9d9", // Light gray border
            borderRadius: "10px", // Rounded edges
          }}
        >
          <Badge
            color={status === "active" ? "green" : "red"}
            text={ToFirstCapital(status)}
            background
          ></Badge>
        </span>
      ),
    },
    {
      title: "Action",
      align: "center",
      key: "action",
      render: (_, record) => (
        <Dropdown
          overlay={
            <Menu>
              {canEdit &&
                <Menu.Item key="edit">
                  <Link to={`/amenities/${record._id}/sub/edit/`}>Edit</Link>
                </Menu.Item>
              }
            </Menu>
          }
        >
          <Button shape="square" icon={<EllipsisOutlined />} />
        </Dropdown>
      ),
    },
  ];

  return (
    <TableComponent
      h3heading={amenityName}
      buttonhead="Go Back"
      navigateTo={`/amenities`}
      buttonhead2={canAdd ? "Add Sub Amenities" : null}
      navigateTo2={canAdd ? `/amenities/${id}/sub/add` : null}
      columns={columns}
      dataSource={Array.isArray(amenitiesResale?.data) ? amenitiesResale.data : []}
      rowKey="_id"
    ></TableComponent>
  );
};

export default ViewAmenities;
